const constants = Object.freeze({
  SUPERADMIN:       "superadmin",
  ADMIN:            "admin",
  RESOURCE_MANAGER: "resource_manager",
  PROGRAM_MANAGER:  "program_manager",
  DATABASE_MANAGER: "database_manager",
  PRESALES_MANAGER: "presales_manager",
  AGENT:            "agent",
  IT_ADMINISTRATOR: "it_administrator",
  MIS_MANAGER:      "mis_manager",
  ALL: [
    "superadmin",
    "admin",
    "resource_manager",
    "presales_manager",
    "program_manager",
    "database_manager",
    "agent",
    "it_administrator",
    "mis_manager",
  ],
  PROGRAM_TYPE_ALL: [
    "Academic Program",
    "Association Program",
    "Audience Generation",
    "Channel Program",
    "Lead Generation",
    "Profiling Activity",
    "Redemption",
    "Reward",
    "Virtual Event",
  ],
  // DND remark labels — must stay in sync with backend DND_REMARKS enum
  DND_CALLING_LABELS: [
    "DND (For Current Campaign)",
    "DND (For Current Brand)",
    "DND (Never Call Again for Any Campaign)",
  ],

  // value === label intentionally — stored as-is in DB and used for filters/DND detection.
  // Do NOT use underscore/snake_case values; it will break DB queries and DND detection.
  CALL_REMARK_OPTIONS: [
    { value: "Registered", label: "Registered" },
    { value: "Already Registered", label: "Already Registered" },
    { value: "Yet to Call", label: "Yet to Call" },
    { value: "Call Back", label: "Call Back" },
    { value: "Call Disconnected", label: "Call Disconnected" },
    { value: "Company Closed", label: "Company Closed" },
    { value: "Company is acquired", label: "Company is acquired" },
    { value: "DND (For Current Campaign)", label: "DND (For Current Campaign)" },
    { value: "DND (For Current Brand)", label: "DND (For Current Brand)" },
    { value: "DND (Never Call Again for Any Campaign)", label: "DND (Never Call Again for Any Campaign)" },
    { value: "Duplicate Contact", label: "Duplicate Contact" },
    { value: "Helpdesk Number", label: "Helpdesk Number" },
    { value: "Interested", label: "Interested" },
    { value: "Need To Confirm", label: "Need To Confirm" },
    { value: "No Number", label: "No Number" },
    { value: "No Number Found (WebSearch)", label: "No Number Found (WebSearch)" },
    { value: "No Response", label: "No Response" },
    { value: "Not Based In Event Location", label: "Not Based In Event Location" },
    { value: "Not Disclosing Official Email ID", label: "Not Disclosing Official Email ID" },
    { value: "Not Interested", label: "Not Interested" },
    { value: "Not Reachable", label: "Not Reachable" },
    { value: "Not Relevant", label: "Not Relevant" },
    { value: "Out Of Order", label: "Out Of Order" },
    { value: "Quit The Company", label: "Quit The Company" },
    { value: "Receptionist Denied To Connect Call", label: "Receptionist Denied To Connect Call" },
    { value: "Send Mail", label: "Send Mail" },
    { value: "SMS Confirmation", label: "SMS Confirmation" },
    { value: "Switched Off", label: "Switched Off" },
    { value: "Tentative", label: "Tentative" },
    { value: "Website Not Found", label: "Website Not Found" },
    { value: "Will Register", label: "Will Register" },
    { value: "Wrong Number", label: "Wrong Number" },
  ],
  // Must match value fields in CALL_REMARK_OPTIONS above (same strings stored in DB)
  REGISTERED_REMARKS: ["Registered", "Already Registered"],
  TURNOVER_RANGE: [
    "1 to 10 Crs",
    "10 to 100 Crs",
    "101 to 250 Crs",
    "251 to 500 Crs",
    "501 to 1000 Crs",
    "1001 to 2500 Crs",
    "2501 to 5000 Crs",
    "5001+ Crs",
  ],
  EMPLOYEES_RANGE: [
    "01 to 50",
    "51 to 100",
    "101 to 250",
    "251 to 500",
    "501 to 1000",
    "1001 to 2500",
    "2501 to 5000",
    "5001 to 10000",
    "10001+",
  ],
  PROGRAM_TYPE_OPTIONS: [
    { value: "Academic_Program", label: "Academic Program" },
    { value: "Association_Program", label: "Association Program" },
    { value: "Audience_Generation", label: "Audience Generation" },
    { value: "Channel_Program", label: "Channel Program" },
    { value: "Lead_Generation", label: "Lead Generation" },
    { value: "Profiling_Activity", label: "Profiling Activity" },
    { value: "Redemption", label: "Redemption" },
    { value: "Reward", label: "Reward" },
    { value: "Virtual_Event", label: "Virtual Event" },
  ],
  PROGRAM_CATEGORY_OPTIONS: [
    { value: "Virtual_Event", label: "Virtual Event" },
    { value: "Webinar", label: "Webinar" },
    { value: "Physical_Event", label: "Physical Event" },
  ],
});

export default constants;
